import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/css';
import { bubbleLabel } from '../Ui';
import { mapOrder, isMA } from '../../utils';
import { textBox } from './InputListWidget';

const wrapper = css`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 10px;
  padding-top: 2px;
  @media (max-width: 940px) {
    display:none;
  }
`;

const totalSelected = (params) => css`
  width: 16px;
  height: 16px;
  line-height: 16px;
  border-radius: 25px;
  border: 1px solid ${params.borderColor};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 7px;
  font-size: 0.6rem;
  font-weight: normal;
  color: ${params?.textColor}
  ${params.isActive && (
    `background:${params.hoverBackgroundColor};
     border: 1px solid ${params?.hoverTextColor};
     color:${params?.hoverTextColor};
    `
  )}
`;

const SelectedFilters = ({
  filters, themeConfig, filterOrder, onBubblesToggle, enableTopLevelBubble,
}) => {
  const [filterOption, setFiterOption] = useState([]);
  useEffect(() => {
    if (filters?.length) {
      setFiterOption(filters);
    }

    if (filterOrder?.length) {
      setFiterOption(mapOrder(filters, filterOrder, 'key'));
    }
  }, [filters, filterOrder]);

  const gradientBackgroundColor = themeConfig?.backgroundColor;

  return (
    <div className={wrapper}>
      {filterOption
        .filter((filter) => isMA() || filter.key !== 'subscriptions')
        .map((filter) => (
          <button
            type="button"
            onClick={enableTopLevelBubble ? onBubblesToggle : undefined}
            key={filter.key}
            className={bubbleLabel({ ...themeConfig, isActive: !!filter?.activeValue?.length, enableTopLevelBubble })}
          >
            <div className={textBox({
              isActive: !!filter?.activeValue?.length,
              isMobile: false,
              gradientBackgroundColor,
              ...themeConfig,
            })}
            >
              <span>{filter.label}</span>
            </div>
            <div className={totalSelected({ ...themeConfig, isActive: !!filter?.activeValue?.length })}>
              {filter?.activeValue?.length}
            </div>
          </button>
        ))}
    </div>
  );
};

SelectedFilters.propTypes = {
  enableTopLevelBubble: PropTypes.bool,
  onBubblesToggle: PropTypes.func,
  themeConfig: PropTypes.object,
  filters: PropTypes.array,
  filterOrder: PropTypes.array,
};

export default SelectedFilters;
